module.exports = __webpack_public_path__ + "static/img/deal_1.cc736231.png";